/**
 * Drill-down mobile nav inside #mobile-menu-drawer (theme mobile-navigation).
 * L2/L3 panels clone from <template> nodes rendered in mobile-menu.liquid.
 */
(function () {
  'use strict';

  var DRAWER_ID = 'mobile-menu-drawer';
  var TRANS_MS = 380;

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function initDrawer(drawer) {
    if (!drawer || drawer.dataset.mobileSlideNavInit === 'true') return;
    drawer.dataset.mobileSlideNavInit = 'true';

    var viewport = qs(drawer, '[data-mobile-slide-viewport]');
    var track = qs(drawer, '[data-mobile-slide-track]');
    var slot2 = qs(drawer, '[data-mobile-slide-slot="2"]');
    var slot3 = qs(drawer, '[data-mobile-slide-slot="3"]');
    var panel1 = qs(drawer, '[data-mobile-slide-slot="1"]');
    var backBtn = qs(drawer, '[data-action="slide-back"]');
    var backTitle = qs(drawer, '.mobile-slide-nav__back-title');

    if (!viewport || !track || !slot2 || !slot3 || !backBtn || !backTitle) return;

    var depth = 0;
    var stack = [];
    var clearTimer = null;

    function setDepth(d, skipTransition) {
      depth = d;
      drawer.style.setProperty('--mobile-slide-depth', String(d));
      if (skipTransition) {
        track.style.transition = 'none';
        void track.offsetWidth;
        track.style.transition = '';
      }
    }

    function updateBackUi() {
      if (depth < 1) {
        backBtn.hidden = true;
        backTitle.textContent = '';
        return;
      }
      backBtn.hidden = false;
      backTitle.textContent = stack.length ? stack[stack.length - 1] : '';
    }

    function scrollPanelToTop(el) {
      if (el) el.scrollTop = 0;
    }

    function resetNav(skipTransition) {
      if (clearTimer) {
        clearTimeout(clearTimer);
        clearTimer = null;
      }
      stack.length = 0;
      slot2.innerHTML = '';
      slot3.innerHTML = '';
      setDepth(0, skipTransition);
      updateBackUi();
      scrollPanelToTop(panel1);
      scrollPanelToTop(slot2);
      scrollPanelToTop(slot3);
    }

    function fillSlot(slot, templateId) {
      slot.innerHTML = '';
      var tpl = null;
      if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
        tpl = drawer.querySelector('#' + CSS.escape(templateId));
      }
      if (!tpl) {
        tpl = document.getElementById(templateId);
      }
      if (tpl && tpl.content) {
        slot.appendChild(tpl.content.cloneNode(true));
      }
    }

    function scheduleClearSlot(slot) {
      clearTimer = setTimeout(function () {
        slot.innerHTML = '';
        clearTimer = null;
      }, TRANS_MS);
    }

    drawer.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-mobile-slide-template]');
      if (openBtn) {
        e.preventDefault();
        var templateId = openBtn.getAttribute('data-mobile-slide-template');
        var backLabel = openBtn.getAttribute('data-slide-back-label') || '';
        var targetRaw = openBtn.getAttribute('data-slide-depth-target');
        var targetDepth = parseInt(targetRaw, 10);
        if (!templateId || (targetDepth !== 2 && targetDepth !== 3)) return;

        if (clearTimer) {
          clearTimeout(clearTimer);
          clearTimer = null;
        }

        if (targetDepth === 2) {
          stack.length = 0;
          slot3.innerHTML = '';
          fillSlot(slot2, templateId);
          stack.push(backLabel);
          setDepth(1);
          scrollPanelToTop(slot2);
        } else {
          fillSlot(slot3, templateId);
          stack.push(backLabel);
          setDepth(2);
          scrollPanelToTop(slot3);
        }
        updateBackUi();
        return;
      }

      if (e.target.closest('[data-action="slide-back"]')) {
        e.preventDefault();
        if (depth < 1) return;

        if (depth === 2) {
          setDepth(1);
          scheduleClearSlot(slot3);
          stack.pop();
        } else if (depth === 1) {
          setDepth(0);
          stack.pop();
          clearTimer = setTimeout(function () {
            slot2.innerHTML = '';
            slot3.innerHTML = '';
            clearTimer = null;
          }, TRANS_MS);
        }
        updateBackUi();
      }
    });

    document.addEventListener('mobile-nav:open', function (e) {
      if (e.target && e.target.id === DRAWER_ID) {
        resetNav(true);
      }
    });

    document.addEventListener('mobile-nav:close', function (e) {
      if (e.target && e.target.id === DRAWER_ID) {
        resetNav(true);
      }
    });

  }

  function boot() {
    var drawer = document.getElementById(DRAWER_ID);
    initDrawer(drawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
